import React from "react";

import styles from "./joyrideTooltip.module.scss";

interface JoyrideTooltipProps {
    children: React.ReactNode;
    adaptiveStyle?: boolean;
}

const JoyrideTooltip: React.FC<JoyrideTooltipProps> = ({ children, adaptiveStyle = false }) => {
    const steper = parseInt(localStorage.getItem("step") || "0", 10);
    const maxSteps = 20;

    const calculatedWidth = (steper / maxSteps) * 100;
    const borderWidth = `${Math.max(calculatedWidth, 20)}%`;

    return (
        <div
            className={adaptiveStyle ? styles.tooltipContainerAdaptive : styles.tooltipContainer}
            style={{ "--border-width": borderWidth } as React.CSSProperties}
        >
            {children}
        </div>
    );
};

export default JoyrideTooltip;
